<template>
  <div class="pageTemplate">
    <v-layout
      row="row"
      wrap="wrap"
    >
      <v-flex xs12>
        <v-layout
          align-center="align-center"
          row="row"
          wrap="wrap"
        >
          <slot name="title" />
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-card
          v-if="card"
          class="mt-3 py-3"
        >
          <v-layout
            row="row"
            wrap="wrap"
          >
            <v-flex
              class="pr-4"
              xs12
            >
              <v-layout wrap>
                <slot name="primaryActions" />
              </v-layout>
            </v-flex>
            <slot name="pre-content" />
            <v-flex xs12>
              <slot name="content" />
            </v-flex>
          </v-layout>
        </v-card>
        <v-layout
          v-else
          row="row"
          wrap="wrap"
          mt-3
        >
          <v-flex
            class="pr-4"
            xs12
          >
            <v-layout wrap>
              <slot name="primaryActions" />
            </v-layout>
          </v-flex>
          <slot name="pre-content" />
          <v-flex xs12>
            <slot name="content" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'PageTemplate',
  props: {
    card: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
